export default __webpack_public_path__ + "static/media/waittime.0c069323.svg";